export default "__VITE_ASSET__C1Y9dfeQ__"